import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {select, Store} from '@ngrx/store';
import {BreadcrumbModel} from '@shared/models/breadcrumb.model';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {QueryProvider} from '@shared/queries/query-provider';
import {Configuration} from '@shared/models/configuration';
import {takeUntil} from 'rxjs/operators';
import {Observable, Subject} from 'rxjs';
import {QueryModel} from '@shared/models/query-model';
import {DeleteQueryAction} from '@shared/store/actions/query.actions';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {
  DeleteSurveyCommand,
  DeleteSurveyExecutionCommand, SurveyTemplateExportCommand, SurveyTemplateReportCommand,
  UpdateSurveyExecution
} from '../../commands/survey.commands';
import {DialogService} from '@shared/services/dialog-service';
import {CommandService} from '@core/services/command.service';
import {getVirtualGridItems} from '@shared/store/selectors/virtual-grid.selector';
import {combineLatest} from 'rxjs';
import {TaskManagerService} from '../../../task-manager/services/task-manager.service';
import {GraphqlContentScope} from '@shared/models/graphql-content-scope.model';
import {take} from 'rxjs/operators';
import { DeleteSurveyAction } from '../../store/actions/data-survey.actions';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import { FileManagementService } from '@core/services/file-management.service';
import { Location } from '@angular/common';
import { DialogModel } from '@shared/models/dialog.model';
import {PlatformCommand} from '@shared/commands/command-base';
@Component({
    standalone: false,
    selector: 'particle-data-survey-content',
  templateUrl: './data-survey-content.component.html',
  styleUrls: ['./data-survey-content.component.scss']
})
export class DataSurveyContentComponent implements OnInit, OnDestroy {
  surveyId: string;
  isClose = false;
  sourceKey: string;
  breadcrumbs: BreadcrumbModel[];
  breadcrumbs$: any;
  breadcrumbKey: string;
  ngUnsubscribe = new Subject<void>();
  private survey$: Observable<any>;
  invalidateSubject = new InvalidateSubject();
  survey: any;
  onComponentInit = true;
  private breadcrumbQueryModel: QueryModel;

  tabs: any[] = [
    {header: 'Survey Templates', sourceKey: 'Data-Survey', id: 'Templates'},
    {header: 'Active Surveys', sourceKey: 'DataSurveyExecution', id: 'ActiveSurveys'},
  ];
  selectedTabIndex: number = 1;
  constructor(protected store: Store<IQueryState>,
              private router: Router,
              private dialogService: DialogService,
              private commandService: CommandService,
              private taskManagerService: TaskManagerService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private fileManagementService: FileManagementService,
              protected activatedRoute: ActivatedRoute,
              private location: Location,
              ) {
    this.sourceKey = 'DataSurveyExecution';

    this.breadcrumbs = [
      <BreadcrumbModel>{
        id: 'DataSurvey',
        title: 'Data Surveys',
        type: 'DataSurvey',
        relativeUrl: 'data-survey'
      }
    ];
    this.breadcrumbKey = 'BreadcrumbBySurveyId';
  }

  ngOnInit() {
    if (window.location.href.indexOf('data-survey/templates') !== -1) {
      this.selectedTabIndex = 0;
    } else { this.selectedTabIndex = 1; }
    /*if (window.location.href.indexOf('data-survey/templates') !== -1) {
      this.selectedTabIndex = 0;
    } else { this.selectedTabIndex = 1; }*/
    // this.activatedRoute.params.subscribe((params: any) => {
    //   //  this.surveyId = params.surveyId;
    //   //  const config = Configuration.getSmartGridConfig(this.sourceKey);
    //   // // config.Parameters['SURVEY_ID'] = this.surveyId;
    //   //  //this.fetchBreadcumbs();
    //   //  //this.fetchSurvey();
    // });

    // const queryParams = this.activatedRoute.queryParams.pipe(takeUntil(this.ngUnsubscribe));
    const gridItems = this.store.pipe(select(getVirtualGridItems, this.sourceKey), takeUntil(this.ngUnsubscribe));
    const shouldOpenTask = this.activatedRoute.snapshot.queryParams &&
      this.activatedRoute.snapshot.queryParams.openTask;
    gridItems.subscribe((result: any) => {
      if (shouldOpenTask && result && result.length > 0) {
        const gridItem = result[0];
        if (this.onComponentInit) {
          this.openSurveyTask(gridItem);
          this.router.navigate(['.'], {relativeTo: this.activatedRoute, queryParams: {}});
          this.onComponentInit = false;
        }
      }
    });

  }

  private fetchBreadcumbs() {
    this.breadcrumbQueryModel = QueryProvider.getQuery(this.breadcrumbKey);
    this.breadcrumbs$ = this.store.pipe(takeUntil(this.ngUnsubscribe), select(getQueryResponse, this.breadcrumbKey));
    this.breadcrumbs$.subscribe(state => {
      if (state) {
        this.breadcrumbs = state.breadcrumb;
      }
    });
    QueryProvider.invokeQuery(this.store, this.breadcrumbKey, {'[ID]': this.surveyId});
  }

  onGridCellValueChange($event) {
    if (this.tabs[this.selectedTabIndex].sourceKey === 'Data-Survey') {
      this.onGridCellManageTemplatesValueChange($event);
    } else if (this.tabs[this.selectedTabIndex].sourceKey === 'DataSurveyExecution') {
      this.onGridCellActiveSurveysValueChange($event);
    }


  }
  onGridCellManageTemplatesValueChange($event) {
    if ($event.fieldDefinition && $event.fieldDefinition.key === 'title') {
      this.router.navigateByUrl(`data-survey/templates/${$event.item.id}/edit`);
    } else if ($event.action && $event.action.id === 'Edit' && $event.item && $event.item.id) {
      this.router.navigate(['../..', $event.item.id, 'edit'], {relativeTo: this.activatedRoute});
    } else if ($event.action && $event.action.id === 'SendDataSurvey' && $event.item && $event.item.id) {
      this.router.navigateByUrl(`data-survey/${$event.item.id}/edit`);
    } else if ($event.action && $event.action.id === 'DesignSurvey' && $event.item && $event.item.id) {
      this.router.navigateByUrl(`data-survey/templates/${$event.item.id}/edit`);
    } else if ($event.action && $event.action.id === 'Delete' && $event.item && $event.item.id) {
      this.dialogService.showYesNoDialog('Delete Survey', 'Are you sure you want to delete this survey?').pipe(takeUntil(this.ngUnsubscribe)).subscribe(result => {
        if (result && result.action === 'OK') {
          const deleteSurveyCommand = new DeleteSurveyCommand([$event.item.id]);
          this.store.dispatch(new DeleteSurveyAction(deleteSurveyCommand, this.invalidateSubject));
        }
      });
    } else if ($event.action && $event.action.id === 'DownloadJson' && $event.item && $event.item.id) {
      this.fuseSplashScreenService.show();
      this.commandService.executeCommand(new SurveyTemplateExportCommand($event.item.id)).pipe().subscribe(response => {
        if (response && response.Payload && response.Payload.Id) {
          this.fileManagementService.downloadClientFileWithId(response.Payload.Id).subscribe(payload => {
            this.fileManagementService.openSaveFileWindow(payload, `Survey Template-${$event.item.cells.title.displayText}.json`);
            this.fuseSplashScreenService.hide();
          });
        }
      });
    } else if ($event.action && $event.action.id === 'DownloadPdf' && $event.item && $event.item.id) {
      this.fuseSplashScreenService.show();
      this.commandService.executeCommand(new SurveyTemplateReportCommand($event.item.id, 'pdf')).pipe().subscribe(response => {
        if (response && response.Payload && response.Payload.Id) {
          this.fileManagementService.downloadClientFileWithId(response.Payload.Id).subscribe(payload => {
            this.fileManagementService.openSaveFileWindow(payload, `Survey Template-${$event.item.cells.title.displayText}.pdf`);
            this.fuseSplashScreenService.hide();
          });
        }
      });
    } else if ($event.action && $event.action.id === 'DownloadDocx' && $event.item && $event.item.id) {
      this.fuseSplashScreenService.show();
      this.commandService.executeCommand(new SurveyTemplateReportCommand($event.item.id, 'docx')).pipe().subscribe(response => {
        if (response && response.Payload && response.Payload.Id) {
          this.fileManagementService.downloadClientFileWithId(response.Payload.Id).subscribe(payload => {
            this.fileManagementService.openSaveFileWindow(payload, `Survey Template-${$event.item.cells.title.displayText}.docx`);
            this.fuseSplashScreenService.hide();
          });
        }
      });
    } else if ($event.action && $event.action.id === 'CopySurvey' && $event.item && $event.item.id) {
      this.addSurvey($event.item.id);
    }
  }
  private onGridCellActiveSurveysValueChange($event) {
    console.log('Data Survey Execution', $event);
    if ($event.action) {
      this.executeAction($event);
    } else {
      if ($event.fieldDefinition && $event.fieldDefinition.key === 'title') {
        this.openSurveyExecution($event);
      }
      if ($event.fieldDefinition && $event.fieldDefinition.key === 'template') {
        this.router.navigateByUrl(`data-survey/templates/${$event.item.cells.template.value.id}/edit`);
      }
    }
  }

  private executeAction($event) {
    switch ($event.action.id) {
      case 'TaskClosed':
        if ($event.updatedState) {
          this.updateTaskStatus($event);
          return;
        }
        break;
      case 'Delete':
        this.dialogService.showYesNoDialog('Delete Survey Execution', 'Are you sure you want to delete this survey execution?').pipe(takeUntil(this.ngUnsubscribe)).subscribe(result => {
          if (result && result.action === 'OK') {
            const command = new DeleteSurveyExecutionCommand([$event.item.id]);
            this.commandService.executeCommand(command).pipe(takeUntil(this.ngUnsubscribe)).subscribe(state => {
              this.invalidateSubject.invalidate();
            });
          }
        });
        return;
      case 'OpenSurveyExecution':
        this.openSurveyExecution($event);
        break;
    }
  }

  addSurvey(copyFromSurveyId: string = null) {
    this.dialogService.showAndStartSurvey('', '', true, {}, copyFromSurveyId);
  }

  startSurvey() {
    this.router.navigateByUrl(`data-survey/${this.surveyId}/edit`);
  }
  editSurvey() {
    this.router.navigateByUrl(`data-survey/${this.surveyId}/edit`);
  }

  private fetchSurvey() {
    this.survey$ = this.store.pipe(takeUntil(this.ngUnsubscribe), select(getQueryResponse, 'SurveyById'));
    this.survey$.subscribe(state => {
      if (state) {
        this.survey = state;
      }
    });
    QueryProvider.invokeQuery(this.store, 'SurveyById', {'[SurveyId]': this.surveyId});
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    // this.store.dispatch(new DeleteQueryAction(this.breadcrumbQueryModel, null, null));
  }

  close() {
    this.isClose = true;
  }

  private openSurveyTask(gridItem: any) {
    const taskKey = 'task';
    if (gridItem.cells[taskKey] && gridItem.cells[taskKey].displayText) {
      console.log('Open Task');
      const task = gridItem.cells[taskKey].value;

      if (task && task.ticketId && task.boardScope) {
        this.taskManagerService.openTaskByTaskId(task.ticketId, GraphqlContentScope.getScope(task.boardScope)).pipe(take(1)).subscribe(state => {
          this.onGridCellValueChange({item: gridItem, fieldDefinition: {key: taskKey}, action: {id: 'TaskClosed'}});
        });
      } else {
        this.onGridCellValueChange({item: gridItem, fieldDefinition: {key: taskKey}, action: {id: 'OpenTask'}});
      }
    } else {
      console.log('Add Task');
      this.taskManagerService.openTaskSelector().pipe(take(1)).subscribe(selectedTask => {
        console.log(selectedTask);
        this.onGridCellValueChange({item: gridItem, fieldDefinition: {key: taskKey}, action: {id: 'AttachTask'}, payload: selectedTask});
      });
    }
  }
  private updateTaskStatus(event: any) {
    const surveyExecutionId = event.item.id;
    const command = new UpdateSurveyExecution(surveyExecutionId);
    this.commandService.executeCommand(command).subscribe(commandState => {
      if (commandState) {
        this.invalidateSubject.invalidate();
      }
    });
  }

  onTabIndexChange(event) {
    this.selectedTabIndex = event;
    if (this.selectedTabIndex === 0) {
      this.location.replaceState(`data-survey/templates`);
    } else {
      this.location.replaceState(`data-survey`);
    }
  }
  importTemplate() {
    this.dialogService.showImportSurveyDialog('', '', true, {});
  }
  addTemplate() {
      const dialogModel: DialogModel = DialogModel.create(
        'Add Template',
        'AddTemplateDialogComponent', {
        },
        '765px',
        '765px'
      );
      this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
        if (res.action === 'OK') {

          const command = new PlatformCommand('CreateSurveyTemplateCommand', 'DataSurveyApi');
          command.fieldValues['Title'] = res.data.input.name;
          command.fieldValues['Description'] = res.data.input.description;
          console.log('Command', command);
          this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(response => {
            console.log('commandState', response);
            const surveyId = response.fieldValues['SurveyId'];
            this.router.navigateByUrl(`data-survey/templates/${surveyId}/edit`);
            },
            error => {
              this.fuseSplashScreenService.hide();
              console.error('Failed CreateSurveyTemplateCommand', error);
            });

        }
      });


  }

  private openSurveyExecution($event: any) {
    const command = new PlatformCommand('CreateSurveyExecutionLinkCommand', 'DataSurveyApi');
    command.fieldValues['ExecutionId'] = $event.item.id;
    command.fieldValues['ViewType'] = 'GridView';
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(response => {
        console.log('commandState', response);
        if (response.fieldValues['RedirectUrl']) {
          this.router.navigateByUrl(response.fieldValues['RedirectUrl']);
        }
      },
      error => {
        this.fuseSplashScreenService.hide();
        console.error('Failed openSurveyExecution ', error);
      });
  }
}
